<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>

    <b-card class="bCardAgenda">
      <b-container fluid="">
        <b-row class="divSubtitulo m-1 mb-3">
          <b-col cols="6" md="8">
            <div>
              <p class="textoSubtitulo">Vales</p>
            </div>
          </b-col>
          <b-col cols="6" md="4">
            <div>
              <p style="text-align:end" class="textoSubtitulo">CÓDIGO: Asignar_vales </p>
            </div>
          </b-col>
        </b-row>
      </b-container>

      <div class="mt-2 col-md-12"></div>

      <b-container fluid="">
        <b-row>
          <b-col>
            <lista-vales-nuevo/>
          </b-col>
        </b-row>
      </b-container>
    </b-card>
  </div>

</template>

<script>
import Header from "@/components/Header.vue";
import ListaValesNuevo from "@/views/vales/listaValesNuevo.vue";

export default {
  components: {
    ListaValesNuevo,
    Header,
  },
  name: "vales",
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  }
}
</script>

<style scoped>
.bCardAgenda {
  margin: 2%;
  padding: 0;
  border-radius: 20px;
}

.bCardAgenda .card-body {
  padding: 0.5rem;
}
</style>